import { useEffect, useState } from "react";
import { useLocation, useNavigate, Outlet } from "react-router-dom";
import PageContainer from "../../Components/Page/PageContainer";
import { TabMenu } from "primereact/tabmenu";
import { Card } from "primereact/card";
import NewIssuesBanner from "../../Components/NewIssuesBanner/NewIssuesBanner";

import { ROUTES } from "../../config/routes";

const SoundRecordings = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState<number>(0);

  // Sync active tab with current route
  useEffect(() => {
    const path = location.pathname;
    // Set active tab based on current route
    if (path.includes(ROUTES.SOUND_RECORDINGS_LINKING_TOOL)) {
      setActiveIndex(0);
    } else if (path.includes(ROUTES.SOUND_RECORDINGS_LINKING_TABLE_VIEW)) {
      setActiveIndex(1);
    } else {
      setActiveIndex(-1); // No tab selected for dashboard
    }
  }, [location.pathname]);

  const handleTabChange = (e: any) => {
    if (e.index === 0) {
      navigate(ROUTES.SOUND_RECORDINGS_LINKING_TOOL);
    } else if (e.index === 1) {
      navigate(ROUTES.SOUND_RECORDINGS_LINKING_TABLE_VIEW);
    }
  };

  const items = [
    { label: "Sound Recording Linking Tool", icon: "pi pi-palette" },
    { label: "Sound Recording Linking Table View", icon: "pi pi-video" },
  ];

  return (
    <>
      {/* Real-time notification banner */}
      <NewIssuesBanner
        collections={["DSRHealthMetrics"]}
        position="top"
        showCount={true}
      />

      <PageContainer
        HomeMenuBarprops={{
          title: (
            <span
              style={{ cursor: "pointer", fontWeight: "bold" }}
              onClick={() => navigate(ROUTES.SOUND_RECORDINGS)}
            >
              Sound Recordings
            </span>
          ),

          Tabs: (
            <TabMenu
              activeIndex={activeIndex}
              onTabChange={handleTabChange}
              model={items}
            />
          ),
        }}
      >
        <div
          style={{
            width: "96%",
            margin: "0 auto",
          }}
        >
          <Card
            unstyled
            style={{
              marginTop: "2rem",
              boxShadow: "none",
            }}
          >
            {/* Use Outlet for sub-routes */}
            <Outlet />
          </Card>
        </div>
      </PageContainer>
    </>
  );
};

export default SoundRecordings;
